import { use } from "react";
import { useLoaderData as useLoaderDataBase } from "react-router-dom";
import {
  App,
  FederatedAuthParams,
  FederatedAuthParamsSchema,
  routes as allRoutes,
  fullEndpoints,
  isNullOrEmptyString,
} from "@songtradr-sso/shared/common";
import { Api, handleMfa } from "../../shared/utils/api.utils";

// TEXT

// STYLES

// DATA
export const exchangeFederatedToken = async (
  authorizationCode: string,
  cognitoOauthState?: string | null,
) => {
  // Make the request to exchange the federated token...
  const result = await Api.request({
    method: "POST",
    url: fullEndpoints[App.Core].auth.exchangeFederatedToken,
    data: {
      state: cognitoOauthState,
      authorization_code: authorizationCode,
      redirect_uri: `${window.location.origin}${window.location.pathname}`,
    },
  });

  // Check for MFA & return verification route if required...
  return handleMfa(result.data.data);
};

// TYPES
export type LoaderData = {
  exchangeFederatedToken: ReturnType<typeof exchangeFederatedToken>;
};

// CONSTANTS
export const routes = allRoutes[App.Core];

// FUNCTIONS
export const useLoaderData = () => {
  const { exchangeFederatedToken } = useLoaderDataBase<LoaderData>();
  return { exchangeFederatedToken: use(exchangeFederatedToken) };
};

export const getFederatedParams = (urlParams: URLSearchParams) => {
  // Convert the URLSearchParams to an object & filter out desired params...
  const { code, state } = Object.fromEntries(urlParams.entries());

  // If code exists, validate federated params...
  const federated = !isNullOrEmptyString(code)
    ? FederatedAuthParamsSchema.parse({ code, state })
    : ({} as FederatedAuthParams);

  return federated;
};

// ASSETS
